module.exports = __webpack_public_path__ + "static/media/tomthumb.343a5dbf.svg";